import {
  B2BProducts,
  B2BMFAProducts,
  AuthFlowType,
  StytchB2BUIConfig,
  B2BOAuthProviders,
} from '@stytch/nextjs/b2b'
import { isGoogleOneTapEnabled } from '@/utilities/stytch/googleOneTapFeature'
import { STYTCH_ACTIVE_SESSION_DURATION, getSharedRedirectURL } from './config'

const STYTCH_CLIENT_EMAIL_TEMPLATE_IDS = {
  login: 'client_portal_login',
  invite: 'client_portal_user_invite',
  resetPassword: 'client_portal_password_reset', // NOSONAR
}

export type ClientOrganizationConfigOptions = {
  enableGoogleOneTap?: boolean
}

export const getOrganizationConfig = (
  options: ClientOrganizationConfigOptions = {},
): StytchB2BUIConfig => {
  const enableGoogleOneTap = options.enableGoogleOneTap ?? isGoogleOneTapEnabled()
  const redirectURL = getSharedRedirectURL()

  return {
    products: [B2BProducts.emailMagicLinks, B2BProducts.passwords, B2BProducts.oauth],
    sessionOptions: { sessionDurationMinutes: STYTCH_ACTIVE_SESSION_DURATION },
    mfaProductInclude: [B2BMFAProducts.totp, B2BMFAProducts.smsOtp],
    mfaProductOrder: [B2BMFAProducts.totp, B2BMFAProducts.smsOtp],
    emailMagicLinksOptions: {
      loginRedirectURL: redirectURL,
      signupRedirectURL: redirectURL,
      loginTemplateId: STYTCH_CLIENT_EMAIL_TEMPLATE_IDS.login,
      signupTemplateId: STYTCH_CLIENT_EMAIL_TEMPLATE_IDS.invite,
    },
    passwordOptions: {
      loginRedirectURL: redirectURL,
      resetPasswordRedirectURL: redirectURL,
      resetPasswordTemplateId: STYTCH_CLIENT_EMAIL_TEMPLATE_IDS.resetPassword,
    },
    oauthOptions: {
      loginRedirectURL: redirectURL,
      signupRedirectURL: redirectURL,
      discoveryRedirectURL: redirectURL,
      providers: [
        {
          type: B2BOAuthProviders.Google,
          one_tap: enableGoogleOneTap,
          cancel_on_tap_outside: true,
        },
      ],
    },
    authFlowType: AuthFlowType.Organization,
  }
}
